export const featuresMap = (featArr: { feature: string; isActive: boolean }[]) => {
  const evalFeat = (value: string) => {
    const feat = featArr.find((el) => el.feature === value);
    return feat ? !!feat.isActive : true;
  };

  return {
    'app.mixpanel': evalFeat('app.mixpanel'),
    'app.wizard.popup(invert)': evalFeat('app.wizard.popup(invert)'),
    'app.partner.branding': evalFeat('app.partner.branding'),
    'app.help.page': evalFeat('app.help.page'),
  };
};
